import script from "./MindCollect.vue?vue&type=script&setup=true&lang=js"
export * from "./MindCollect.vue?vue&type=script&setup=true&lang=js"

import "./MindCollect.vue?vue&type=style&index=0&id=6f9f45bc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9f45bc"]])

export default __exports__